fetch('/cart.js')
.then(response => response.json())
.then(async cart => {
    window.Shopify.cart = cart;
    document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
                cart: cart,
            }
        })
    );  
})
.catch(error => console.error('Error fetching the cart:', error));
document.addEventListener('line-item:change:end', function (e) {
  console.log("line-item:change:end",e)
  handleCartgiftproductEvent(e)
});
document.addEventListener('cart:item-added', function (e) {
  fetch('/cart.js')
  .then(response => response.json())
  .then(async cart => {
      window.Shopify.cart = cart;
      document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                  cart: cart,
              }
          })
      );  
  })
})

document.addEventListener('cart:refresh', function (e) {
  handleCartgiftproductEvent(e)
})
function handleCartgiftproductEvent(event){
    var cart = event.detail.cart;
    // if(cart.additem){
    //     window.Shopify.cart.items.push(cart.additem)
    //     cart = window.Shopify.cart
    // }else{
        window.Shopify.cart = cart;
    // }
    
  if(cart && cart.items && cart.items.length == 0){
    return;
  }
  console.log("item",cart)
  
  var giftProductInCart = false;
  var giftProductQty = 0;
  var giftProductVariantID = [];
cart.items.forEach(function (item) {
  if (item.product_id == window.giftProductVariant.product_id) {
    giftProductInCart = true;
    giftProductQty += item.quantity || 1;
    giftProductVariantID.push(item.id)
  }
});
  var giftProductPrice = 0;
  var giftProductDiscount = 0;
  // Find the gift product in the cart items and get its price
  var giftProduct = cart.items.find(function (item) {
    return item.product_id == window.giftProductVariant.product_id;
  });
  if (giftProduct) {
    giftProductPrice = giftProduct.final_line_price
    giftProductDiscount = giftProduct.total_discount
  }
//   var line_items_final_price = 0;
//   cart.items.forEach((item)=>{
//     line_items_final_price += item.final_line_price;
//   })
//   var cartTotal = line_items_final_price - cart.total_discount + giftProductDiscount -  giftProductPrice;
  var cartTotal = cart.total_price;
  var giftProductChangeNum = 0;
  if(cartTotal >= window.giftProductVariant.price) {
    giftProductChangeNum = 1;
  }

  if ((!giftProductInCart && giftProductChangeNum == 1) || (giftProductInCart && giftProductChangeNum == 0) || ( giftProductInCart && giftProductQty > 1 )){
    let updates = {};
    if(giftProductChangeNum == 1){
        updates = {
            [window.giftProductVariant.id]: giftProductChangeNum
          };
        if(giftProductQty > 1){
          giftProductVariantID.forEach(function(vid,index){
            if(index==0)
            {
              updates[vid] = giftProductChangeNum;
            }else{
              updates[vid] = 0;
            }
          });
        }
    }else{
        window.giftProductVariant.product.forEach((item,index)=>{
            updates[item.id] = 0;
        })
    }
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
            cart: data,
        }
          })
        );
      })
      .catch((error) => {
        console.error('Error:', error);
    });
  }
}
